import type { InputTextProps } from '@carboncopyco/ui';
import { InputText, TextCaption } from '@carboncopyco/ui';
import { forwardRef } from 'react';
import { InputField } from '../InputField';

interface VariableFormInputProps extends InputTextProps {
  label: string;
  name: string;
  error?: string;
}

export const VariableFormInput = forwardRef<
  HTMLInputElement | HTMLTextAreaElement,
  VariableFormInputProps
>(
  (
    { label, name, value, onChange, onFocus, error, autoFocus, disabled },
    ref
  ) => {
    return (
      <InputField
        label={label}
        name={name}
        error={
          error && (
            <TextCaption
              color="text-ds-danger"
              label={error}
            />
          )
        }
      >
        <InputText
          ref={ref}
          onFocus={onFocus}
          autoFocus={autoFocus}
          name={name}
          disabled={disabled}
          size="lg"
          value={value}
          onChange={onChange}
          state={error ? 'error' : 'normal'}
        />
      </InputField>
    );
  }
);
VariableFormInput.displayName = 'VariableFormInput';
